export default __webpack_public_path__ + "static/media/jackets-banner.deab1b01.jpeg";